module.exports = __webpack_public_path__ + "static/media/tpn-events-v2-sketches.ab34f9dd.jpg";